// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"223":"ac03cb6a2b406de771ff","245":"b8e0e47c12a595279324","452":"742df8b2f45d5ddbb4cf","453":"f2118e4eede311d8d2b2","896":"84866075fdbd0cfef9cf"}[chunkId] + ".js";
};